/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to set consent response for MultiPax session
 * @export
 * @interface PaxCheckSetConsentRequest
 */
export interface PaxCheckSetConsentRequest {
    /**
     * Consent response
     * @type {boolean}
     * @memberof PaxCheckSetConsentRequest
     */
    consent: boolean;
}

/**
 * Check if a given object implements the PaxCheckSetConsentRequest interface.
 */
export function instanceOfPaxCheckSetConsentRequest(value: object): value is PaxCheckSetConsentRequest {
    if (!('consent' in value) || value['consent'] === undefined) return false;
    return true;
}

export function PaxCheckSetConsentRequestFromJSON(json: any): PaxCheckSetConsentRequest {
    return PaxCheckSetConsentRequestFromJSONTyped(json, false);
}

export function PaxCheckSetConsentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckSetConsentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'consent': json['consent'],
    };
}

export function PaxCheckSetConsentRequestToJSON(json: any): PaxCheckSetConsentRequest {
    return PaxCheckSetConsentRequestToJSONTyped(json, false);
}

export function PaxCheckSetConsentRequestToJSONTyped(value?: PaxCheckSetConsentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'consent': value['consent'],
    };
}

